import { c as _c } from "react/compiler-runtime";
import { HotelCardReservationInfoPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-action/hotel-card-reservation-info/hotel-card-reservation-info.types";
import { numberConvert } from "@website/utils/number-convert";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { FC } from "react";
export const HotelCardReservationInfo: FC<HotelCardReservationInfoPropertiesType> = properties => {
  const $ = _c(16);
  const router = useCompatRouter();
  const {
    date_from,
    date_to
  } = router.query;
  const {
    nightCount,
    size: t0,
    roomTitle,
    isLanding,
    isHotelDomHomePage
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const appName = process.env.NEXT_PUBLIC_APP_NAME || "";
  const hasDateAndPassengers = Boolean(date_from && date_to && router?.query?.room_capacity && Number(router?.query?.room_capacity) > 0);
  const shouldShowFromPerNight = appName === "villa" && Boolean(hasDateAndPassengers);
  const t1 = `flex flex-col items-start justify-end ${isLanding ? "w-1/2" : ""} ${size === "small" ? "" : "lg:items-center"}`;
  let t2;
  if ($[0] !== isHotelDomHomePage || $[1] !== isLanding || $[2] !== roomTitle || $[3] !== router.locale || $[4] !== size) {
    t2 = roomTitle && size !== "xSmall" && (["hotel-domestic", "tour"].includes(appName) || isHotelDomHomePage) && <div className={`flex ${size === "small" ? isLanding ? "max-w-full" : "max-w-[145px]" : "max-w-[175px]"} items-center gap-1 pb-2 md:py-2 lg:justify-center`}><span className="text-caption text-on-surface-high-emphasis truncate" data-testid="hotel_card_room_title">{numberConvert(roomTitle, {
          numberOnly: false,
          locale: router.locale
        })}</span></div>;
    $[0] = isHotelDomHomePage;
    $[1] = isLanding;
    $[2] = roomTitle;
    $[3] = router.locale;
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== nightCount || $[7] !== router.locale || $[8] !== router.query.room_capacity || $[9] !== shouldShowFromPerNight || $[10] !== size) {
    t3 = size === "small" ? <div className="flex flex-col items-start gap-1">{shouldShowFromPerNight ? <span className="text-on-surface-medium-emphasis text-caption">{` مجموع ${numberConvert(router?.query?.room_capacity || 1, {
          locale: router?.locale
        })} نفر و ${numberConvert(nightCount, {
          locale: router?.locale
        })} شب`}</span> : <span className="text-on-surface-medium-emphasis text-caption">قیمت از شبی</span>}</div> : nightCount ? <div className="text-body-2 text-on-surface-high-emphasis flex items-center justify-start gap-1 font-medium lg:justify-center">{`${numberConvert(nightCount, {
        locale: router.locale
      })} شب`}</div> : null;
    $[6] = nightCount;
    $[7] = router.locale;
    $[8] = router.query.room_capacity;
    $[9] = shouldShowFromPerNight;
    $[10] = size;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};